import { CONTENT_API_URL, CONTACT_API_URL, API_TIMEOUT_MS } from "../config";

const withTimeout = (promise, ms) =>
  Promise.race([
    promise,
    new Promise((_, reject) => setTimeout(() => reject(new Error("timeout")), ms))
  ]);

/**
 * PHP backend'den tüm site içeriğini getirir.
 * Hata / boş URL durumunda null döner (çağıran taraf mock'a düşer).
 */
export async function fetchContent() {
  if (!CONTENT_API_URL) return null;
  try {
    const res = await withTimeout(
      fetch(CONTENT_API_URL, {
        method: "GET",
        headers: { Accept: "application/json" },
        credentials: "omit"
      }),
      API_TIMEOUT_MS
    );
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const data = await res.json();
    return data && typeof data === "object" ? data : null;
  } catch (err) {
    // Sessizce mock'a düşer
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.warn("[content] API'den içerik alınamadı, mock kullanılıyor:", err.message);
    }
    return null;
  }
}

/**
 * İletişim formu gönderimi. URL yoksa mock başarı döner.
 */
export async function submitContact(payload) {
  if (!CONTACT_API_URL) {
    await new Promise((r) => setTimeout(r, 800));
    return { ok: true, mocked: true };
  }
  try {
    const res = await withTimeout(
      fetch(CONTACT_API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify(payload)
      }),
      API_TIMEOUT_MS
    );
    const data = await res.json().catch(() => ({}));
    if (!res.ok || data.ok === false) {
      return { ok: false, error: data.error || `HTTP ${res.status}` };
    }
    return { ok: true };
  } catch (err) {
    return { ok: false, error: err.message };
  }
}
